import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledBox = styled(Box)`
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
`;
